const routes = [
  {
    path: '',
    name: 'EducationCourseList',
    component: () => import('./pages/CourseList.vue'),
    meta: {
      title: 'Мои курсы',
      authorize: [],
    },
  },
  {
    path: '/meeting/:id',
    name: 'Meeting',
    component: () => import('./pages/Meeting.vue'),
    meta: {
      title: 'Видеоконференция урока',
      authorize: [],
      isMeeting: true,
      mini: true,
    },
  },
  {
    path: '/:courseId/units',
    component: () => import('./pages/CoursePassing/Course.vue'),
    children: [
      {
        path: '',
        name: 'EducationCourseUnitList',
        component: () => import('./pages/CoursePassing/children/UnitsList.vue'),
        meta: {
          title: 'Темы курса',
          authorize: [],
          breadcrumbs: {
            parent: 'EducationCourseList',
          },
        },
      },
      {
        path: ':unitId/lessons',
        name: 'EducationLessonList',
        component: () => import('./pages/CoursePassing/children/LessonList.vue'),
        meta: {
          title: 'Уроки',
          authorize: [],
          breadcrumbs: {
            parent: 'EducationCourseUnitList',
          },
        },
      },
      {
        path: ':unitId/lessons/:lessonId',
        name: 'EducationLesson',
        component: () => import('./pages/CoursePassing/children/LessonTaskList.vue'),
        meta: {
          title: 'Урок',
          authorize: [],
          breadcrumbs: {
            parent: 'EducationCourseUnitList',
          },
        },
      },
    ],
  },

  {
    path: '/:courseId/units/:unitId/lessons/:lessonId/materials',
    name: 'EducationLessonMaterials',
    component: () => import('./pages/LessonMaterials.vue'),
    meta: {
      title: 'Материалы урока',
      authorize: [],
      breadcrumbs: {
        parent: 'EducationLessonList',
      },
    },
  },
];

export default routes;
